
let site = `${process.env.VUE_APP_URL}`;
let ENV = {
        rise:`${site}/${process.env.VUE_APP_RISE}`,
        stock:`${site}/${process.env.VUE_APP_STOCK}`,
        money:`${site}/${process.env.VUE_APP_MONEY}`,
        kwebservice:`${site}/${process.env.VUE_APP_SERVICE}`,
        name:process.env.VUE_APP_NAME,
    }

export default ENV;